'use strict';

import React from 'react';

import Select from './Select';
import ListProducts from './ListProducts';

class Products extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
        }
    }

    getUrl(type, category)
    {
        let url = type ? '/api/products/'+ type : null;

        if (url)
            url += category ? '/'+ category : '';

        return url;
    }

    render()
    {
        const { type, category } = this.props.match.params;
        const { types, categories } = this.state;

        return (
            <section className="produto-sec categories">
                <aside className="cat_header">
                    <div className="container">
                        <div className="cat-box">
                            {/* <Select
                                classe="right"
                                placeholder="Escolha uma opção"
                                value={ type }
                                options='/api/types'
                                parent='/produtos/' /> */}
                            <Select
                                classe="left full"
                                placeholder="Escolha uma opção"
                                value={ category }
                                options={ type ? '/api/categories/'+ type : null }
                                parent={ '/produtos/'+ type +'/' } />
                        </div>
                    </div>
                </aside>

                <ListProducts
                    url={ this.getUrl(type, category) } />
            </section>
        )
    }
}

export default Products;


// WEBPACK FOOTER //
// ./resources/assets/js/app/components/Products.js